import ProgressIndicator from 'components/ProgressIndicator';

import { STEPS } from './constants';

const ProgressHeaderIndicator: React.FunctionComponent = function () {
  return (
    <div className="lg:hidden flex flex-col sticky top-[65px] md:top-[73px] z-50">
      <ProgressIndicator items={STEPS} lastPassed />
    </div>
  );
};

export default ProgressHeaderIndicator;
